import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import SlimSelect from 'slim-select'

gsap.registerPlugin(ScrollTrigger)

export default class Contact {
  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.contact--form')

    this.reveal()

    if (!this.form) return

    this.mailer = this.form.dataset.mailer

    this.initSlimSelect()
    this.bindCheckbox()
    this.bindSubmit()
  }

  // le panneau d'un <select> natif est rendu par l'OS et non stylable :
  // SlimSelect le remplace par du DOM, monté dans le bloc pour hériter de son scope
  initSlimSelect() {
    const select = this.form.querySelector('.contact--select')
    if (!select) return

    new SlimSelect({
      select,
      settings: {
        showSearch: false,
        contentLocation: this.el,
      },
    })
  }

  reveal() {
    const targets = [
      this.el.querySelector('.contact--subtitle'),
      this.el.querySelector('.contact--title'),
      this.form,
    ].filter(Boolean)

    if (!targets.length) return

    gsap.set(targets, { y: 30, opacity: 0 })

    gsap.to(targets, {
      y: 0,
      opacity: 1,
      duration: 0.9,
      stagger: 0.12,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: this.el,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  }

  bindCheckbox() {
    // le <label> coche déjà nativement l'input associé : ne pas dupliquer le toggle en JS
    this.el.querySelectorAll('.contact--checkbox-container').forEach((container) => {
      container.addEventListener('click', (e) => {
        // le clic sur le lien RGPD ne doit pas cocher la case
        if (e.target.closest('.contact--rgpd-link')) e.preventDefault()
      })
    })
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam && amispam.value) {
        console.error('Oh no ! I m Spam')
        return
      }

      const formData = new FormData(this.form)

      this.setState('loading')

      fetch(this.mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            return response.text().then((text) => {
              throw new Error(`HTTP ${response.status} — ${this.mailer}\n${text}`)
            })
          }
          return response
        })
        .catch(error => console.error('[contact]', error))
        .finally(() => {
          this.setState('sent')
          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
          }, 5000)
        })
    })
  }

  setState(state) {
    this.form.querySelectorAll('.contact--submit').forEach(btn => btn.classList.remove('is-active'))
    const target = this.form.querySelector(`.contact--submit.is-${state}`)
    if (target) target.classList.add('is-active')
  }
}
